<template>
  <a href="/" class="">
    <img src="/images/logo.svg" alt="logo" class="h-14" />
  </a>
</template>
